import { render, staticRenderFns } from "./PriceIncrease.vue?vue&type=template&id=564e6d14&scoped=true"
import script from "./PriceIncrease.vue?vue&type=script&lang=js"
export * from "./PriceIncrease.vue?vue&type=script&lang=js"
import style0 from "./PriceIncrease.vue?vue&type=style&index=0&id=564e6d14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564e6d14",
  null
  
)

export default component.exports